// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    max-width: 1320px;
    margin: 0 auto;
    display: flex;
    height: 100vh;
    width: 100%;
    flex-direction: column;
    margin-left: 100px;
  }`, "",{"version":3,"sources":["webpack://./src/components/MainLayout/Mainlayout.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,kBAAkB;EACpB","sourcesContent":[".container {\n    max-width: 1320px;\n    margin: 0 auto;\n    display: flex;\n    height: 100vh;\n    width: 100%;\n    flex-direction: column;\n    margin-left: 100px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
